const SET_TITLE = '@@app/SET_TITLE';
const TOGGLE_MENU = '@@app/TOGGLE_MENU';
const OPEN_MODAL = '@@app/OPEN_MODAL';
const CLOSE_MODAL = '@@app/CLOSE_MODAL';
const CONNECTION_ERROR = '@@app/CONNECTION_ERROR';

const initialState = {
    menuTitle: 'Meny',
    menuOpen: false,
    modalOpen: false,
    focusSearch: false,
    error: null,
};

export default function app(state = initialState, action) {
    switch (action.type) {
    case SET_TITLE:
        return Object.assign({}, state, {
            menuTitle: action.page,
        });
    case TOGGLE_MENU:
        return Object.assign({}, state, {
            menuOpen: !state.menuOpen,
            focusSearch: action.focusSearch || false,
        });
    case OPEN_MODAL:
        return Object.assign({}, state, { modalOpen: action.modal || null });
    case CLOSE_MODAL:
        return Object.assign({}, state, { modalOpen: null });
    case CONNECTION_ERROR:
        return Object.assign({}, state, { error: action.error });
    default:
        return state;
    }
}

export function changePage(page) {
    return { type: SET_TITLE, page };
}

export function toggleMenu(focusSearch = false) {
    return { type: TOGGLE_MENU, focusSearch };
}

export function openModal(modal) {
    return { type: OPEN_MODAL, modal };
}

export function closeModal() {
    return { type: CLOSE_MODAL };
}

export function showConnectionError(error) {
    return { type: CONNECTION_ERROR, error };
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/app.js
 **/